import { CircleAlert } from 'lucide-react';
import { cn } from '@design-system';

export type PillTone = 'live' | 'draft' | 'unavailable' | 'changes' | 'off';

const TONES: Record<PillTone, { className: string; dot: string | null }> = {
  live: { className: 'bg-[#E7F6EC] text-[#1B6B3A]', dot: 'bg-[#1E8E4A]' },
  draft: { className: 'bg-zinc-100 text-zinc-700', dot: 'bg-zinc-400' },
  off: { className: 'bg-zinc-100 text-zinc-700', dot: 'bg-zinc-400' },
  changes: { className: 'bg-[#FFF4E5] text-[#8A4B00]', dot: 'bg-[#C77700]' },
  unavailable: { className: 'bg-[#FFF4E5] text-[#8A4B00]', dot: null },
};

/** A reply's state in a word or two: Live, Draft, Not available yet… */
export function StatusPill({ tone, children }: { tone: PillTone; children: React.ReactNode }) {
  const { className, dot } = TONES[tone];
  return (
    <span
      className={cn(
        'inline-flex shrink-0 items-center gap-1.5 rounded-full px-2.5 py-1 text-[13px] font-semibold',
        className,
      )}
    >
      {dot ? (
        <span
          className={cn('size-[7px] rounded-full', dot)}
          aria-hidden
        />
      ) : (
        <CircleAlert
          className="size-3.5"
          aria-hidden
        />
      )}
      {children}
    </span>
  );
}
